import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  user: {},
  error: '', // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
  pending2fa: false,
  pendingToken: null,
  twoFactorMethod: null,
  passwordExpired: false,
  passwordChangeToken: null,
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload.data;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.errorMsg = false;
      state.pending2fa = false;
      state.pendingToken = null;
      state.twoFactorMethod = null;
      state.passwordExpired = false;
      state.passwordChangeToken = null;
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
    },
    reset_login_flag(state) {
      state.error = null;
      state.loading = false;
      state.errorMsg = false;
    },
    twoFactorPending(state, action) {
      state.pending2fa = true;
      state.pendingToken = action.payload.pendingToken;
      state.twoFactorMethod = action.payload.method;
      state.passwordExpired = false;
      state.passwordChangeToken = null;
      state.loading = false;
      state.errorMsg = false;
    },
    passwordExpiredPending(state, action) {
      state.passwordExpired = true;
      state.passwordChangeToken = action.payload.passwordChangeToken;
      state.loading = false;
      state.errorMsg = false;
    },
  },
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  twoFactorPending,
  passwordExpiredPending,
} = loginSlice.actions;

export default loginSlice.reducer;
